// extracted by mini-css-extract-plugin
export default {"container":"elements_container__0ngNm","section":"elements_section__YEBvX","section_hr":"elements_section_hr__4toPi","about_page_container":"elements_about_page_container__k-91m"};